import * as THREE from "three"
import SceneObjectData from "../model/sceneObjectData/SceneObjectData"

export const isFullyVisible = (obj: THREE.Object3D): boolean => {
    let current: THREE.Object3D | null = obj;
    while (current !== null) {
        if (!current.visible) return false;
        current = current.parent;
    }
    return true;
};
/* 
const getAllSceneObjectGeometries = (scene : THREE.Scene, sceneObjectIds: UUID[] ) : THREE.Object3D[] {
    const results = sceneObjectIds.map(id => scene.getObject)
} */

export const getSceneObjectDataFromObject3D = (object : THREE.Object3D) : SceneObjectData | null => {
    if (object instanceof THREE.Group && object.userData && object.userData instanceof SceneObjectData) {
        return object.userData;
    }
    
    if (object.parent) {
        return getSceneObjectDataFromObject3D(object.parent);
    }

    return null;

}